import React, { useEffect } from 'react';
import './Admin.css';
import { getLoginUserDetails } from '../../api/adminuserapi';
import AdminLinkTile from '../../components/admin/admin-link-tile';
import { useDispatch } from "react-redux";
import { showLoading, hideLoading, delayedHideLoading } from '../../store/loading-reducer';

function Admin() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(showLoading());
    }, [dispatch]);

    useEffect(() => {
        dispatch(showLoading());
        getLoginUserDetails()
            .then(() => {
                dispatch(delayedHideLoading());
            }).catch(() => {
                dispatch(hideLoading());
            });
    }, []);
    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                &nbsp;
            </div>
            <div className="admin-page-content">
                <div className="admin-link-tile-wrap">
                    <AdminLinkTile
                        href="/inbox"
                        icon="school"
                        name="Inbox"
                    />
                </div>
            </div>
        </div>
    );
}

export default Admin;